import { Button } from '@mantine/core';
import { IconUserX } from '@tabler/icons-react';
import { User } from 'interfaces/user';
import { MRT_Row } from 'mantine-react-table';

interface DisableUserButtonProps {
  id: string;
  handleDisableUser: (id: string) => Promise<void>;
  row: MRT_Row<User>;
}

export const DisableUserButton: React.FC<DisableUserButtonProps> = ({
  id,
  handleDisableUser,
  row,
}) => {
  const disabled = row.original.status === 'disabled';

  return (
    <Button
      variant="outline"
      radius={'md'}
      leftSection={<IconUserX />}
      color="red"
      data-testid="disable-user-button"
      onClick={() => handleDisableUser(id)}
    >
      {disabled ? 'Enable User' : 'Disable User'}
    </Button>
  );
};
